import {IAppInfoResponse} from '../../interfaces/services';
import {extractRemoteVersion} from './extractRemoteVersion';
import {validateVersion} from './validateVersion';
import {isWebApp} from '../platform/is-web';

export const verifyIsOutdated = (payload: IAppInfoResponse['payload']) => {
  try {
    if (!isWebApp) {
      const remoteVersion = extractRemoteVersion(payload);
      const result = validateVersion(remoteVersion);
      return result;
    }
  } catch {}

  return true;
};
